<span [class.work-ui-badge--circle]="circle"
      [class.work-ui-badge--clickable]="clickable"
      [class.work-ui-badge--disabled]="disabled"
      [class.work-ui-badge--removable]="removable"
      [class.work-ui-badge--text-wrap]="textWrap"
      [ngClass]="[
        iconName ? 'flex gap-8 flew-row vertical-center' : ''
       ]"
      [workUiTooltip]="title"
      class="work-ui-badge work-ui-badge--{{size}} work-ui-badge--{{variant}} work-ui-badge--{{borderStyle}}">
  <work-ui-icon [fontSize]="16"
                [name]="iconName" />
  {{ text + '' | translate }}
  @if (removable) {
    <work-ui-icon (click)="emitRemoveClick()"
                  [fontSize]="20"
                  name="close"
    ></work-ui-icon>
  }
</span>
